import { getProductFeaturesByFieldUuid } from 'product-features/selectors';
import { getActiveUserId } from 'current/selectors';
import {
  fetchEligibleProducts,
  fetchProductFeaturesByField
} from 'product-features/loaders';
import {
  processEligibleProducts,
  processProductFeaturesForField
} from 'product-features/processors';

import { isEmpty } from 'lodash';

export const findProductFeaturesByFieldUuid = async ({ dispatch, getState, fieldUuid }) => {
  const state = getState();
  const features = getProductFeaturesByFieldUuid(state, fieldUuid);
  if( !isEmpty(features) ) {
    return features;
  }
  const userId = getActiveUserId(state);

  const rawProductFeatures = await fetchProductFeaturesByField({ userId, fieldUuid });
  return processProductFeaturesForField({ dispatch, rawProductFeatures });
};

export const findEligibleProducts = async ({ dispatch, getState }) => {
  const state = getState();
  const userId = getActiveUserId(state);
  const rawEligibleProducts = await fetchEligibleProducts(userId);
  return processEligibleProducts({ dispatch, rawEligibleProducts });
};
